import { GenericOverlayBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/generic-overlay-box';

interface Props {
  title: string;
  children: JSX.Element;
  topColor?: string;
}

export function EmptyInfoBox(props: Props) {
  return <GenericOverlayBox title={props.title}>{props.children}</GenericOverlayBox>;
}
